/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-404[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;padding-top:20px}\n/*# sourceMappingURL=custom-404.style.css.map*/"];
export { styles as styles };
